/** SVG path hit testing and bounds (M/L/H/V/C/Q/Z subset). */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { parsePathSegments } from './pathGeometry';
function pointInPolygon(x, y, pts) {
    var inside = false;
    for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) {
        var xi = pts[i].x;
        var yi = pts[i].y;
        var xj = pts[j].x;
        var yj = pts[j].y;
        if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) {
            inside = !inside;
        }
    }
    return inside;
}
function distToSegment(px, py, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    var lenSq = dx * dx + dy * dy;
    if (lenSq === 0)
        return Math.hypot(px - x1, py - y1);
    var t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lenSq));
    return Math.hypot(px - (x1 + t * dx), py - (y1 + t * dy));
}
export function pathContainsPoint(d, localX, localY, strokeWidth) {
    var e_1, _a;
    var _b;
    if (strokeWidth === void 0) { strokeWidth = 1; }
    if (typeof Path2D !== 'undefined' && typeof document !== 'undefined') {
        try {
            var canvas = document.createElement('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            if (ctx && 'isPointInPath' in ctx) {
                var path = new Path2D(d);
                if (ctx.isPointInPath(path, localX, localY))
                    return true;
                var strokeCtx = ctx;
                if (strokeWidth > 0 && ((_b = strokeCtx.isPointInStroke) === null || _b === void 0 ? void 0 : _b.call(strokeCtx, path, localX, localY)))
                    return true;
            }
        }
        catch (_c) {
            /* parser fallback */
        }
    }
    var segments = parsePathSegments(d);
    var tolerance = Math.max(strokeWidth, 4);
    try {
        for (var segments_1 = __values(segments), segments_1_1 = segments_1.next(); !segments_1_1.done; segments_1_1 = segments_1.next()) {
            var seg = segments_1_1.value;
            if (seg.length < 2)
                continue;
            var closed_1 = seg.length > 2 &&
                Math.hypot(seg[0].x - seg[seg.length - 1].x, seg[0].y - seg[seg.length - 1].y) < 0.01;
            if (closed_1 && pointInPolygon(localX, localY, seg))
                return true;
            for (var i = 0; i < seg.length - 1; i++) {
                if (distToSegment(localX, localY, seg[i].x, seg[i].y, seg[i + 1].x, seg[i + 1].y) <= tolerance) {
                    return true;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (segments_1_1 && !segments_1_1.done && (_a = segments_1.return)) _a.call(segments_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
export function pathBounds(d) {
    var e_2, _a, e_3, _b;
    var segments = parsePathSegments(d);
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    try {
        for (var segments_2 = __values(segments), segments_2_1 = segments_2.next(); !segments_2_1.done; segments_2_1 = segments_2.next()) {
            var seg = segments_2_1.value;
            try {
                for (var seg_1 = (e_3 = void 0, __values(seg)), seg_1_1 = seg_1.next(); !seg_1_1.done; seg_1_1 = seg_1.next()) {
                    var p = seg_1_1.value;
                    minX = Math.min(minX, p.x);
                    minY = Math.min(minY, p.y);
                    maxX = Math.max(maxX, p.x);
                    maxY = Math.max(maxY, p.y);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (seg_1_1 && !seg_1_1.done && (_b = seg_1.return)) _b.call(seg_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (segments_2_1 && !segments_2_1.done && (_a = segments_2.return)) _a.call(segments_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    if (!isFinite(minX))
        return { x: 0, y: 0, width: 0, height: 0 };
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
export { parsePathSegments } from './pathGeometry';
